import assertNever from 'assert-never';
import { Guid } from '@ef-carbon/primitive';
import isIDiscourseExpected from '../discourse/isIExpected';
import isIDiscourseStatement from '../discourse/isIStatement';
import Walker from './Walker';
export class FormationProcessor {
    constructor(options) {
        this.context = {};
        this.walker = new Walker(options);
        const descriptors = Object.getOwnPropertyDescriptors(this);
        descriptors.walker.enumerable = false;
        descriptors.walker.writable = false;
        descriptors.walker.configurable = false;
        descriptors.context.enumerable = false;
        descriptors.context.configurable = false;
        Object.defineProperties(this, descriptors);
    }
    get cache() {
        return this.walker.cache;
    }
    set cache(value) {
        this.walker.cache = value;
    }
    get options() {
        return this.walker.options;
    }
    set options(value) {
        this.walker.options = value;
    }
    get id() {
        return this.walker.id;
    }
    get start() {
        return this.walker.start;
    }
    get discourse() {
        return this.walker.discourse;
    }
    get link() {
        return this.walker.link;
    }
    get redirect() {
        return this.walker.redirect;
    }
    get tags() {
        return this.walker.tags;
    }
    get meta() {
        return this.walker.meta;
    }
    get features() {
        return this.walker.features;
    }
    async next(id) {
        const {done, value} = await this.walker.next(id ? [
            id,
            this.context
        ] : this.context);
        if (done || !value) {
            return {
                done: true,
                value: id ? new Guid(id) : this.start
            };
        }
        return this.result(done, value);
    }
    async return() {
        const {done, value} = await this.walker.return();
        return {
            done,
            value: value ? value.id : this.start
        };
    }
    async result(done, value) {
        const {
            id: guid,
            discourse,
            context
        } = value;
        this.context = await this.process(discourse, context);
        return {
            done,
            value: guid
        };
    }
    [Symbol.asyncIterator]() {
        return this;
    }
    async throw(error) {
        await this.walker.throw(error);
        throw error;
    }
    async process(discourse, context) {
        if (isIDiscourseStatement(discourse)) {
            return this.statement(discourse, context);
        } else if (isIDiscourseExpected(discourse)) {
            return this.expected(discourse, context);
        } else {
            return assertNever(discourse);
        }
    }
}
export {
    FormationProcessor as Processor
};
export default FormationProcessor;    //# sourceMappingURL=Processor.js.map
